import React from "react";

const ProgressSteps = ({ steps = [], currentStep = 1, onStepClick }) => {
  const safeStep = Math.max(1, currentStep);
    const progressPercentage = steps.length > 1 ? (safeStep / steps.length) * 100 : 100;

  return (
    <div className="min-w-md text-white bg-secondary-2 flex flex-col h-full">
      {/* Fixed header section */}
      <div className="mb-8 flex-shrink-0">
        <p className="text-sm">
          Step {safeStep} of {steps.length}
        </p>
        <div className="w-full h-2 bg-[#FFFFFF33] rounded-full mt-3 overflow-hidden">
          <div
            className="h-2 bg-misc-progress rounded-full transition-all"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Scrollable steps section */}
      <div className="flex-1 overflow-y-auto space-y-6 scrollbar-track-transparent scrollbar-thumb-transparent hover:scrollbar-thumb-transparent scrollbar-thumb-rounded-full scroll-hide">
        {steps.map((step, index) => {
          const stepNumber = index + 1; // now 1-based
          const isDone = stepNumber < safeStep;
          const isActive = stepNumber === safeStep;
          const isClickable = isDone || isActive;

          const handleStepClick = () => {
            if (isClickable && onStepClick) {
              onStepClick(stepNumber);
            }
          };

          return (
            <div key={index} className="flex items-start gap-4">
              <div
                className={`
                  flex items-center justify-center rounded-full shrink-0 mt-[4px]
                  ${isDone ? "w-[26px] h-[26px] bg-misc-progress" : ""}
                  ${isActive ? "w-[26px] h-[26px] border-[1.4px] border-white" : ""}
                  ${!isDone && !isActive ? "w-[26px] h-[26px] border-[1.4px] border-gray-500 bg-transparent" : ""}
                `}
              >
                {isDone ? (
                  <svg
                    viewBox="0 0 16 16"
                    className="w-4 h-4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.5 8.5 L6.5 11.5 L12.5 5.5"
                      stroke="#0B0B0B"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : isActive ? (
                  <div className="flex items-center justify-center w-[20px] h-[20px] rounded-full bg-white">
                    <span className="text-[12px] font-bold text-secondary-2">
                      {stepNumber}
                    </span>
                  </div>
                ) : null}
              </div>

              <div>
                <p 
                  className={`text-base font-medium text-neutral-1 pb-1 ${
                    isClickable 
                      ? 'cursor-pointer hover:text-white transition-colors duration-200' 
                      : 'cursor-default'
                  }`}
                  onClick={handleStepClick}
                >
                  {step.label}
                </p>
                {step.subtitle && (
                  <p className="text-sm font-light text-[#FFFFFF99] whitespace-pre-line">
                    {step.subtitle}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export { ProgressSteps };